module.exports = __webpack_public_path__ + "static/media/profile.f65b71c9.svg";